import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const useStyles = makeStyles(() => ({
  modalFooter: {
    background: `${colors.white} !important`,
  },
}));

type ConfirmationModalBodyTextProps = {
  isError?: boolean;
};

export const ConfirmationModalBodyText = styled("span")(
  ({ isError }: ConfirmationModalBodyTextProps) => ({
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: 0.5,
    color: isError ? colors.error600 : colors.gray600,
    marginBottom: "8px",
  })
);

export const ConfirmationModalBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.white,
}));
